export const environment = {
  production: false,
  api: 'https://hml.api.clozzy.com.br/v1'
};
